module.exports = __webpack_public_path__ + "static/media/pagination-next-page.9f2bed40.svg";